import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck, faCheckCircle, faSearch, faBars, faPlus, faMinus, faTimes, faInfo, faInfoCircle, faUser, faUsers, faCloud, faSlash, faExclamationCircle, faChevronUp, faChevronDown, faCircle, faFlag, faCamera, faTrashAlt,
  faUpload, faLightbulb, faExclamation, faArrowUp, faEllipsisV, faFile, faSignOutAlt, faTh, faQuestionCircle, faFileUpload, faHome, faUserCircle
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faCheck,
  faCheckCircle,
  faSearch,
  faBars,
  faPlus,
  faMinus,
  faTimes,
  faInfo,
  faInfoCircle,
  faUser,
  faUsers,
  faCloud,
  faSlash,
  faExclamationCircle,
  faChevronUp,
  faChevronDown,
  faCircle,
  faFlag,
  faCamera,
  faTrashAlt,
  faUpload,
  faLightbulb,
  faExclamation,
  faArrowUp,
  faEllipsisV,
  faFile,
  faSignOutAlt,
  faTh,
  faQuestionCircle,
  faFileUpload,
  faHome,
  faUserCircle
);
